<template>
    <div class="progress display--flex">
        <div class="progress__bar position--relative background--grey">
            <div class="progress__bar__success position--absolute background--green" :style="`width: ${percentage}%`"></div>
        </div>
        <div class="progress__info color--green">{{ value }}%</div>
    </div>
</template>

<script>
// packages
import { ref } from '@vue/composition-api';

export default {
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    setup ( props ) {
        const percentage = ref( 0 );

        setTimeout( () => {
            percentage.value = props.value;
        }, 500 );

        return { percentage };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Style
    // =============================================================================
    .progress {
        align-items: center;
        &__bar {
            @include dimensions( 70%, 23px );
            @include rounded-corner( 20px );
            margin-right: auto;
            overflow: hidden;
            will-change: width;
            &__success {
                height: 100%;
                transition: width 1s ease-in-out;
            }
        }
    }
</style>